import { Input, Modal, Spin } from "antd"
import { useEffect, useRef, useState } from "react";
import axios from "axios";
import openAiChatCompletion from "controllers/openAiChatCompletion";

const backend = process.env.REACT_APP_BACKEND;

function WrongWordInput ({record, dataChangeHandler, gptModel}) {
  const [wrongWord, setWrongWord] = useState(record.wrong_word)
  const [loading, setLoading] = useState(false)
  const ref = useRef(record.wrong_word)

  const changeValue = async () => {
    try {
      setLoading(true)
      const instance = JSON.parse(JSON.stringify(record))
      instance.wrong_word = wrongWord
      const values = {
        id: record.id, 
        word: record.word,
        ContentSettingPartsOfSpeechMaster_code: record.ContentSettingPartsOfSpeechMaster_code,
        wrong_word: wrongWord
      }

      const changePhonetic = await axios.patch(`${backend}/contents/new_word/constituent_false/master`,{values})
      if(changePhonetic.status === 200) {
        dataChangeHandler(instance, "wrong_word")
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호를 변경하지 못했습니다.",
        okText:"확인",
        afterClose: ()=>{setWrongWord(record.wrong_word)}
      })
    } finally {
      setLoading(false)
    }
  }

  const createByGpt = async () => {
    const { word, pos_name, cefr_evp, translate_text} = record
    const prompt = `Provide one English word opposite or irrelevant to '${word}' that is a(n) ${pos_name} at the ${cefr_evp} CEFR level meaning ${translate_text}. Make sure to select the word whose part of the speech and CEFR level is the same. Provide only the English word without any explanation or other cues.`
    const translateTextByGpt = await openAiChatCompletion(prompt, gptModel)

    if(!translateTextByGpt) {
      Modal.error({
        title: "GPT에러",
        content: "gpt에 오류가 발생했습니다. 답변 형식이 잘못되어 있을 수 있으니 console을 확인하세요.",
        okText:"확인",
      })
    }
    
    return translateTextByGpt.toLowerCase()
  }

  const createByGptHandler = async () => {
    try {
      setLoading(true)
      const wrongWord = await createByGpt()
      if(!wrongWord) {
        setLoading(false)
        return
      }

      const instance = JSON.parse(JSON.stringify(record))
      instance.wrong_word = wrongWord
      const values = {
        id: record.id, 
        word: record.word,
        ContentSettingPartsOfSpeechMaster_code: record.ContentSettingPartsOfSpeechMaster_code,
        wrong_word: wrongWord
      }

      const changePhonetic = await axios.patch(`${backend}/contents/new_word/constituent_false/master`,{values})
      if(changePhonetic.status === 200) {
        dataChangeHandler(instance, "wrong_word")
      }
    } catch (err) {
      console.log(err)
      Modal.error({
        title:"에러",
        content: "서버에서 에러가 발생하여 발음기호를 변경하지 못했습니다.",
        okText:"확인",
        afterClose: ()=>{setWrongWord(record.wrong_word)}
      })
    } finally {
      setLoading(false)
    }
  }

  useEffect(()=>{
    setWrongWord(record.wrong_word)
  },[record])

  return (
    <div>
      <Spin spinning={loading}>
        <Input 
          style={{width:"150px"}} 
          value={wrongWord} 
          onFocus={()=>ref.current=wrongWord}
          onChange={(e)=>setWrongWord(e.target.value)}
          onBlur={changeValue}
        />
        <a style={{margin:"0px 5px"}} disabled={!record.translate_text} onClick={!record.translate_text ? null : createByGptHandler}>생성</a>
      </Spin>
  </div>
  )
}

export default WrongWordInput